import { resolveUrl } from '@rbx/env-utils';

/**
 * This registry is the single source of truth for all frontend client settings managed by admin site.
 * keep consistent with Roblox.Platform.ClientSettings.Properties.ClientApplications value for CreatorDashboard
 *   Prod: https://admin.simulprod.com/application-settings?groupName=Roblox.Platform.ClientSettings.Properties.ClientApplications&namePattern=CreatorDashboard
 *   Sitetest1: https://admin.sitetest1.simulpong.com/application-settings?groupName=Roblox.Platform.ClientSettings.Properties.ClientApplications&namePattern=CreatorDashboard&valuePattern=
 */
export enum FeatureFlagName {
  enableExample = 'enableExample',
  enableActivityFeedLocation = 'enableActivityFeedLocation',
  enableManualTranslationFeedback = 'enableManualTranslationFeedback',
  enableDeveloperSubscriptionUpdateRevShareDemo = 'enableDeveloperSubscriptionUpdateRevShareDemo',
  enableCommerce = 'enableCommerce',
  enableAccountInformation = 'enableAccountInformation',
  enableResourceListNewArrakisBehavior = 'enableResourceListNewArrakisBehavior',
  enableRemoveShutDownServersButton = 'enableRemoveShutDownServersButton',
  enableAutomaticTranslationUpdates = 'enableAutomaticTranslationUpdates',
  dynamicPriceFloorAssetWhitelist = 'dynamicPriceFloorAssetWhitelist',
  enableBundlePaginationOffset = 'enableBundlePaginationOffset',
  enableLocalizationCsvManagement = 'enableLocalizationCsvManagement',
  enableUENSocialMentions = 'enableUENSocialMentions',
  enableBadgeReordering = 'enableBadgeReordering',
  useNewShutdownAllInstancesEndpoint = 'useNewShutdownAllInstancesEndpoint',
  personalizationBannerWhitelist = 'personalizationBannerWhitelist',
  personalizationBannerIdsGated = 'personalizationBannerIdsGated',
  enableShowOnlyPublishedPlaceVersions = 'enableShowOnlyPublishedPlaceVersions',
  isOldAutomaticTextCaptureDisabled = 'isOldAutomaticTextCaptureDisabled',
  enableMeshTextureApisToggle = 'enableMeshTextureApisToggle',
  meshTextureApisUsagePolicyUrl = 'meshTextureApisUsagePolicyUrl',
  enableDevexMaintenanceBanner = 'enableDevexMaintenanceBanner',
  enablePlaceSelectForEvent = 'enablePlaceSelectForEvent',
  enableBoundAuthTokenValidationOptIn = 'enableBoundAuthTokenValidationOptIn',
  boundAuthTokenTokenValidationOptInIframeLoadTimeout = 'boundAuthTokenTokenValidationOptInIframeLoadTimeout',
  boundAuthTokenValidationOptInSAIRequestTimeout = 'boundAuthTokenValidationOptInSAIRequestTimeout',
  enableItemDelisting = 'enableItemDelisting',
  isContentMaturityRenameEnabled = 'isContentMaturityRenameEnabled',
  ownershipTransferCompletedTimeout = 'ownershipTransferCompletedTimeout',
  affiliateProgramAllowlist = 'affiliateProgramAllowlist',
  isAffiliateProgramEnabled = 'isAffiliateProgramEnabled',
  enablePlayerFeedback = 'enablePlayerFeedback',
  enablePlayerFeedbackCommentFilter = 'enablePlayerFeedbackCommentFilter',
  enablePlayerFeedbackSummary = 'enablePlayerFeedbackSummary',
  enablePlayerFeedbackUnrated = 'enablePlayerFeedbackUnrated',
  affiliateProgramTermsKey = 'affiliateProgramTermsKey',
  migrateAssetPermissionsParams = 'migrateAssetPermissionsParams',
  enableAffiliateLinkGAData = 'enableAffiliateLinkGAData',
  affiliateLinkGADataAllowlist = 'affiliateLinkGADataAllowlist',
  enableUseStudioEditPlaceLauncherWithPrelaunch = 'enableUseStudioEditPlaceLauncherWithPrelaunch',
  allowUpdatingBundleName = 'allowUpdatingBundleName',
  disableJuneNinthLaunchAnnouncementRegionalPricing = 'disableJuneNinthLaunchAnnouncementRegionalPricing',
  enableEnvironments = 'enableEnvironments',
  enableYourPlaceCreation = 'enableYourPlaceCreation',
  enableYourPlaceCreationExperimentDate = 'enableYourPlaceCreationExperimentDate',
  enableScopeSelectionCategoryWarning = 'enableScopeSelectionCategoryWarning',
  enableGroupOwnershipTransferV2 = 'enableGroupOwnershipTransferV2',
  enableCreatorControlsAgeGate = 'enableCreatorControlsAgeGate',
  enableCreatorControlsGeoGate = 'enableCreatorControlsGeoGate',
  enableCreatorRewards = 'enableCreatorRewards',
  creatorRewardsAllowlist = 'creatorRewardsAllowlist',
  enableGroupInvitationsFriendTags = 'enableGroupInvitationsFriendTags',
  enableGroupInvitationsTelemetry = 'enableGroupInvitationsTelemetry',
  enableUGCFolders = 'enableUGCFolders',
  unratedExperienceBannerLink = 'unratedExperienceBannerLink',
  serverManagementEnabled = 'serverManagementEnabled',
  enableTargetPartWildcards = 'enableTargetPartWildcards',
  enableChildLocaleSupport = 'enableChildLocaleSupport',
  enableRentables = 'enableRentables',
  enableRentablesBulkUpdateButton = 'enableRentablesBulkUpdateButton',
  rentablesPreLaunchWhitelist = 'rentablesPreLaunchWhitelist',
  rentablesPostLaunchWhitelist = 'rentablesPostLaunchWhitelist',
  enableContentMaturity18Plus = 'enableContentMaturity18Plus',
  enableTaxonomyInPricingPage = 'enableTaxonomyInPricingPage',
  enableTaxonomyInConfigurePage = 'enableTaxonomyInConfigurePage',
  enableMakeupAssets = 'enableMakeupAssets',
  enableOneTimePayoutV2 = 'enableOneTimePayoutV2',
  enableFirstPayoutWarning = 'enableFirstPayoutWarning',
  enableQuestionnaireHelpDialog = 'enableQuestionnaireHelpDialog',
  enableDeveloperSubscriptionsInRobux = 'enableDeveloperSubscriptionsInRobux',
  devSubsInRobuxAllowlist = 'devSubsInRobuxAllowlist',
  questionnaireV2Allowlist = 'questionnaireV2Allowlist',
  questionnaireV2Q1Release = 'questionnaireV2Q1Release',
  questionnaireV2Q2Release = 'questionnaireV2Q2Release',
  enableAgeVerificationUpsellBanner = 'enableAgeVerificationUpsellBanner',
  ageVerificationUpsellBannerStartDate = 'ageVerificationUpsellBannerStartDate',
  ageVerificationUpsellBannerEndDate = 'ageVerificationUpsellBannerEndDate',
  ageVerificationUpsellBannerHighPriorityDate = 'ageVerificationUpsellBannerHighPriorityDate',
  ageVerificationUpsellGetStartedUrl = 'ageVerificationUpsellGetStartedUrl',
  ageVerificationUpsellViewDetailsUrl = 'ageVerificationUpsellViewDetailsUrl',
  serverManagementV2Enabled = 'serverManagementV2Enabled',
  serverManagementV2Whitelist = 'serverManagementV2Whitelist',
  enableMigratedAvatarAnalyticsPage = 'enableMigratedAvatarAnalyticsPage',
  enableGPCFooter = 'enableGPCFooter',
  enableSignalRCrossTab = 'enableSignalRCrossTab',
  enableIpPlatformManualMatchRequests = 'enableIpPlatformManualMatchRequests',
  showTaxonomyOnAvatarItemAnalyticsTab = 'showTaxonomyOnAvatarItemAnalyticsTab',
  enableSecureTeleports = 'enableSecureTeleports',
  showTaxonomyAnnouncementBanner = 'showTaxonomyAnnouncementBanner',
  enableServerDrivenTShirtUploadFee = 'enableServerDrivenTShirtUploadFee',
  serverManagementIncreaseRestartDelay = 'serverManagementIncreaseRestartDelay',
  serverManagementCustomPayloadReady = 'serverManagementCustomPayloadReady',
  enableEstablishTrustUpsellBanner = 'enableEstablishTrustUpsellBanner',
  establishTrustUpsellBannerStartDate = 'establishTrustUpsellBannerStartDate',
  establishTrustUpsellGetStartedUrl = 'establishTrustUpsellGetStartedUrl',
  establishTrustUpsellViewDetailsUrl = 'establishTrustUpsellViewDetailsUrl',
  enableStarterPlaceEligibility = 'enableStarterPlaceEligibility',
  starterPlaceTemplateId = 'starterPlaceTemplateId',
  enableTalentHubV2 = 'enableTalentHubV2',
  enableTalentHubV2M2 = 'enableTalentHubV2M2',
  enablePlaceModerationCheckBeforeStudioOpen = 'enablePlaceModerationCheckBeforeStudioOpen',
  enableIpPlatformTimeboundLicenses = 'enableIpPlatformTimeboundLicenses',
  enablePrivateServerNonFreePriceUpdate = 'enablePrivateServerNonFreePriceUpdate',
  enableBlackbird = 'enableBlackbird',
  enablePrivateServerRegionalPricing = 'enablePrivateServerRegionalPricing',
  impactedExperiencesDevForumUrl = 'impactedExperiencesDevForumUrl',
  impactedExperiencesAgeLearnMoreUrl = 'impactedExperiencesAgeLearnMoreUrl',
  impactedExperiencesTrustedLearnMoreUrl = 'impactedExperiencesTrustedLearnMoreUrl',
  enableGroupModerationPage = 'enableGroupModerationPage',
  impactedExperiencesMaxConsecutiveEmptyPages = 'impactedExperiencesMaxConsecutiveEmptyPages',
  impactedExperiencesMaxUniverseIds = 'impactedExperiencesMaxUniverseIds',
  taxonomyDocumentationUrl = 'taxonomyDocumentationUrl',
  isHdEnabled = 'isHdEnabled',
  enableReducedMarketplaceVisibilityBanner = 'enableReducedMarketplaceVisibilityBanner',
  enableCoreContentStatusTooltipFooter = 'enableCoreContentStatusTooltipFooter',
  publishEligibilityDevForumUrl = 'publishEligibilityDevForumUrl',
  enableCoreContentStatusLabelLink = 'enableCoreContentStatusLabelLink',
}

export type FeatureFlagValue = string | number | boolean;

// Helper preserves literal value types per key and enforces all enum keys are present
const defineFeatureFlagDefaults = <T extends { readonly [K in FeatureFlagName]: FeatureFlagValue }>(
  t: T,
) => t;

export const featureFlagDefaults = defineFeatureFlagDefaults({
  [FeatureFlagName.enableExample]: false,
  [FeatureFlagName.enableActivityFeedLocation]: false,
  [FeatureFlagName.enableManualTranslationFeedback]: false,
  [FeatureFlagName.enableDeveloperSubscriptionUpdateRevShareDemo]: false,
  [FeatureFlagName.enableCommerce]: false,
  [FeatureFlagName.enableAccountInformation]: false,
  [FeatureFlagName.enableResourceListNewArrakisBehavior]: false,
  [FeatureFlagName.enableRemoveShutDownServersButton]: false,
  [FeatureFlagName.enableAutomaticTranslationUpdates]: false,
  [FeatureFlagName.dynamicPriceFloorAssetWhitelist]: '',
  [FeatureFlagName.enableBundlePaginationOffset]: true,
  [FeatureFlagName.enableLocalizationCsvManagement]: false,
  [FeatureFlagName.enableUENSocialMentions]: false,
  [FeatureFlagName.enableBadgeReordering]: false,
  [FeatureFlagName.useNewShutdownAllInstancesEndpoint]: false,
  [FeatureFlagName.personalizationBannerWhitelist]: '',
  [FeatureFlagName.personalizationBannerIdsGated]: '',
  [FeatureFlagName.enableShowOnlyPublishedPlaceVersions]: false,
  [FeatureFlagName.isOldAutomaticTextCaptureDisabled]: false,
  [FeatureFlagName.enableMeshTextureApisToggle]: false,
  [FeatureFlagName.meshTextureApisUsagePolicyUrl]: resolveUrl(
    'creatorsRestrictionsOnUse',
    process.env.targetEnvironment,
    process.env.buildTarget,
  ),
  [FeatureFlagName.enableDevexMaintenanceBanner]: false,
  [FeatureFlagName.enablePlaceSelectForEvent]: false,
  [FeatureFlagName.enableBoundAuthTokenValidationOptIn]: false,
  [FeatureFlagName.boundAuthTokenTokenValidationOptInIframeLoadTimeout]: 10000,
  [FeatureFlagName.boundAuthTokenValidationOptInSAIRequestTimeout]: 10000,
  [FeatureFlagName.enableItemDelisting]: false,
  [FeatureFlagName.isContentMaturityRenameEnabled]: false,
  [FeatureFlagName.ownershipTransferCompletedTimeout]: 60,
  [FeatureFlagName.affiliateProgramAllowlist]: '',
  [FeatureFlagName.isAffiliateProgramEnabled]: false,
  [FeatureFlagName.enablePlayerFeedback]: false,
  [FeatureFlagName.enablePlayerFeedbackCommentFilter]: false,
  [FeatureFlagName.enablePlayerFeedbackSummary]: false,
  [FeatureFlagName.enablePlayerFeedbackUnrated]: false,
  [FeatureFlagName.affiliateProgramTermsKey]: '',
  [FeatureFlagName.migrateAssetPermissionsParams]: false,
  [FeatureFlagName.enableAffiliateLinkGAData]: false,
  [FeatureFlagName.affiliateLinkGADataAllowlist]: '',
  [FeatureFlagName.enableUseStudioEditPlaceLauncherWithPrelaunch]: false,
  [FeatureFlagName.allowUpdatingBundleName]: false,
  [FeatureFlagName.disableJuneNinthLaunchAnnouncementRegionalPricing]: false,
  [FeatureFlagName.enableEnvironments]: false,
  [FeatureFlagName.enableYourPlaceCreation]: false,
  [FeatureFlagName.enableYourPlaceCreationExperimentDate]: new Date('2025-09-23').toISOString(),
  [FeatureFlagName.enableScopeSelectionCategoryWarning]: false,
  [FeatureFlagName.enableGroupOwnershipTransferV2]: false,
  [FeatureFlagName.enableCreatorControlsAgeGate]: false,
  [FeatureFlagName.enableCreatorControlsGeoGate]: false,
  [FeatureFlagName.enableCreatorRewards]: false,
  [FeatureFlagName.creatorRewardsAllowlist]: '',
  [FeatureFlagName.enableGroupInvitationsFriendTags]: false,
  [FeatureFlagName.enableGroupInvitationsTelemetry]: false,
  [FeatureFlagName.enableUGCFolders]: false,
  [FeatureFlagName.unratedExperienceBannerLink]: '',
  [FeatureFlagName.serverManagementEnabled]: false,
  [FeatureFlagName.enableTargetPartWildcards]: false,
  [FeatureFlagName.enableChildLocaleSupport]: false,
  [FeatureFlagName.enableRentables]: false,
  [FeatureFlagName.enableRentablesBulkUpdateButton]: false,
  [FeatureFlagName.rentablesPreLaunchWhitelist]: '',
  [FeatureFlagName.rentablesPostLaunchWhitelist]: '',
  [FeatureFlagName.enableContentMaturity18Plus]: false,
  [FeatureFlagName.enableTaxonomyInPricingPage]: false,
  [FeatureFlagName.enableTaxonomyInConfigurePage]: false,
  [FeatureFlagName.enableMakeupAssets]: false,
  [FeatureFlagName.enableOneTimePayoutV2]: false,
  [FeatureFlagName.enableFirstPayoutWarning]: false,
  [FeatureFlagName.enableQuestionnaireHelpDialog]: false,
  [FeatureFlagName.enableDeveloperSubscriptionsInRobux]: false,
  [FeatureFlagName.devSubsInRobuxAllowlist]: '',
  [FeatureFlagName.questionnaireV2Allowlist]: '',
  [FeatureFlagName.questionnaireV2Q1Release]: false,
  [FeatureFlagName.questionnaireV2Q2Release]: false,
  [FeatureFlagName.enableAgeVerificationUpsellBanner]: false,
  [FeatureFlagName.ageVerificationUpsellBannerStartDate]: new Date('2025-12-03').toISOString(),
  [FeatureFlagName.ageVerificationUpsellBannerEndDate]: new Date('2026-06-01').toISOString(),
  [FeatureFlagName.ageVerificationUpsellBannerHighPriorityDate]: new Date(
    '2026-01-21',
  ).toISOString(),
  [FeatureFlagName.ageVerificationUpsellGetStartedUrl]:
    'https://www.roblox.com/my/account?creatorCollaboration',
  [FeatureFlagName.ageVerificationUpsellViewDetailsUrl]:
    'https://devforum.roblox.com/t/age-check-notifications-in-studio-and-creator-hub/4117693',
  [FeatureFlagName.serverManagementV2Enabled]: false,
  [FeatureFlagName.serverManagementV2Whitelist]: '',
  [FeatureFlagName.enableMigratedAvatarAnalyticsPage]: false,
  [FeatureFlagName.enableGPCFooter]: false,
  [FeatureFlagName.enableSignalRCrossTab]: false,
  [FeatureFlagName.enableIpPlatformManualMatchRequests]: false,
  [FeatureFlagName.showTaxonomyOnAvatarItemAnalyticsTab]: false,
  [FeatureFlagName.enableSecureTeleports]: false,
  [FeatureFlagName.showTaxonomyAnnouncementBanner]: false,
  [FeatureFlagName.serverManagementIncreaseRestartDelay]: false,
  [FeatureFlagName.enableServerDrivenTShirtUploadFee]: false,
  [FeatureFlagName.serverManagementCustomPayloadReady]: false,
  [FeatureFlagName.enableEstablishTrustUpsellBanner]: false,
  [FeatureFlagName.establishTrustUpsellBannerStartDate]: new Date('2026-02-28').toISOString(),
  [FeatureFlagName.establishTrustUpsellGetStartedUrl]:
    'https://www.roblox.com/my/account?creatorCollaboration',
  [FeatureFlagName.establishTrustUpsellViewDetailsUrl]:
    'https://devforum.roblox.com/t/age-check-notifications-in-studio-and-creator-hub/4117693',
  [FeatureFlagName.enableStarterPlaceEligibility]: false,
  [FeatureFlagName.starterPlaceTemplateId]: 102012632106276,
  [FeatureFlagName.enableTalentHubV2]: false,
  [FeatureFlagName.enableTalentHubV2M2]: false,
  [FeatureFlagName.enablePlaceModerationCheckBeforeStudioOpen]: false,
  [FeatureFlagName.enableIpPlatformTimeboundLicenses]: false,
  [FeatureFlagName.enablePrivateServerNonFreePriceUpdate]: false,
  [FeatureFlagName.enableBlackbird]: false,
  [FeatureFlagName.enablePrivateServerRegionalPricing]: false,
  [FeatureFlagName.impactedExperiencesDevForumUrl]: 'https://devforum.roblox.com/',
  [FeatureFlagName.impactedExperiencesAgeLearnMoreUrl]:
    'https://en.help.roblox.com/hc/en-us/articles/39143693116052-Understanding-Age-Checks-on-Roblox',
  [FeatureFlagName.impactedExperiencesTrustedLearnMoreUrl]:
    'https://en.help.roblox.com/hc/en-us/articles/37725513985812-Unlocking-Trusted-Connections-Expressive-Chat-Features-Party-Voice-chat-without-filters',
  [FeatureFlagName.enableGroupModerationPage]: false,
  [FeatureFlagName.impactedExperiencesMaxConsecutiveEmptyPages]: 10,
  [FeatureFlagName.impactedExperiencesMaxUniverseIds]: 3,
  [FeatureFlagName.taxonomyDocumentationUrl]:
    'https://create.roblox.com/docs/marketplace/categories',
  [FeatureFlagName.isHdEnabled]: false,
  [FeatureFlagName.enableReducedMarketplaceVisibilityBanner]: false,
  [FeatureFlagName.enableCoreContentStatusTooltipFooter]: false,
  [FeatureFlagName.publishEligibilityDevForumUrl]: '',
  [FeatureFlagName.enableCoreContentStatusLabelLink]: false,
} as const);
